module.exports = __webpack_public_path__ + "static/img/ID@2x.265f9b5e.jpg";